import React, { useState } from 'react';
import { Box, Container, Typography, Tab, Tabs, Button } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import CreateAdminForm from '../components/admin/CreateAdminForm';
import CreateModeratorForm from '../components/admin/CreateModeratorForm';
import AdminList from '../components/admin/AdminList';
import ModeratorList from '../components/admin/ModeratorList';
import Logs from '../components/admin/Logs';
import instance from '../utils/axiosConfig';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index} style={{ marginTop: '20px' }}>
      {value === index && children}
    </div>
  );
}

function AdminDashboard() {
  const [tabValue, setTabValue] = useState(0);
  const [syncing, setSyncing] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const triggerDistributorSync = async () => {
    try {
      setSyncing(true);
      await instance.post('/api/admin-management/trigger-distributor-sync');
      alert('Sincronización de distribuidores completada');
    } catch (error) {
      console.error('Error triggering sync:', error);
      alert('Error al sincronizar distribuidores');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Panel de Administración
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<SyncIcon />}
          onClick={triggerDistributorSync}
          disabled={syncing}
        >
          {syncing ? 'Sincronizando...' : 'Sincronizar Distribuidores'}
        </Button>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Crear Admin" />
          <Tab label="Crear Moderador" />
          <Tab label="Lista de Admins" />
          <Tab label="Lista de Moderadores" />
          <Tab label="Logs del Sistema" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <CreateAdminForm />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <CreateModeratorForm />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <AdminList />
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <ModeratorList />
      </TabPanel>
      <TabPanel value={tabValue} index={4}>
        <Logs />
      </TabPanel>
    </Container>
  );
}

export default AdminDashboard; 